/**
 * Created by fulle on 2023/02/07.
 */
import http from "@/http-common";
import CUSTOM_CONSTANTS from "@/constants";


export default {
  state: {
      selected: null,
      list: {
          all: null,
          paginated: null
      },
      pagination: null,
      links: null

  },
  mutations: {
      SET_DOCUMENT_LIST_ALL: (state, _value) => {
          state.list.all = _value;
      },
      SET_SELECTED_DOCUMENT: (state, _value) => {
          state.selected = _value;
      },
      SET_DOCUMENT_LIST_PAGINATED: (state, _value) => {
          state.list.paginated = _value;
      },
      UPDATE_DOCUMENT_LIST_PAGINATED: (state, _value) => {
          Array.prototype.push.apply(state.list.paginated,_value)
          let _arr = state.list.paginated
          state.list.paginated = _arr.filter((value, index) => {
              const _value = JSON.stringify(value);
              return index === _arr.findIndex(obj => {
                      return JSON.stringify(obj) === _value;
                  });
          });
      },
      SET_DOCUMENT_PAGINATION: (state, _value) => {
          state.pagination = _value;
      },
      SET_DOCUMENT_PAGINATION_LINKS: (state, _value) => {
          state.links = _value;
      },
  },
  actions: {

      COMMIT_SET_SELECTED_DOCUMENT: ({ commit}, _value) => {
          commit("SET_SELECTED_DOCUMENT", _value);
      },
      COMMIT_SET_DOCUMENT_LIST_PAGINATED: ({ commit}, _value) => {
          commit("SET_DOCUMENT_LIST_PAGINATED", _value);
      },
      REQUEST_DOCUMENT_LIST_PAGINATED: ({ commit,dispatch }, _formData) => {
          commit("START_PROCESSING", { root: true });
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          return new Promise(resolve => {
              http({
                  url: '/document/list',
                  method: "POST",
                  timeout: 30000,
                  data: _formData
              })
                  .then(_response => {
                      window.console.log("Response DOCUMENT PAGINATED LIST: ", _response);
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      let _page = 1
                      if(typeof _formData !== "undefined" && _formData !== null)
                      {
                          if(typeof _formData.page !== "undefined" && _formData.page !== null && isNumeric(_formData.page)&&parseInt(_formData.page)>0)
                              _page = parseInt(_formData.page)
                      }
                      if(_page <= 1)
                          commit('SET_DOCUMENT_LIST_PAGINATED', _response.data.data);
                      else
                          commit('UPDATE_DOCUMENT_LIST_PAGINATED', _response.data.data);
                      commit('SET_DOCUMENT_PAGINATION', _response.data.pagination);
                      commit('SET_DOCUMENT_PAGINATION_LINKS', _response.data.links);
                      commit("STOP_PROCESSING", { root: true });
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_DOCUMENT_LIST_SELECT: ({ commit,dispatch }, _formData) => {
          commit("START_PROCESSING", { root: true });
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          return new Promise(resolve => {
              http({
                  url: '/document/select',
                  method: "POST",
                  timeout: 30000,
                  data: _formData
              })
                  .then(_response => {
                      window.console.log("Response DOCUMENT PAGINATED LIST: ", _response);
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      commit('SET_DOCUMENT_LIST_ALL', _response.data.data);
                      commit("STOP_PROCESSING", { root: true });
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_DOCUMENT_SAVE: ({ commit,dispatch, reject }, _formData) => {
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          commit("START_PROCESSING", { root: true });
          return new Promise(resolve => {
              http({
                  url: '/document/save',
                  method: "POST",
                  timeout: 30000,
                  data: _formData,
                  headers: {
                      'Content-Type': 'multipart/form-data',
                      'enctype': 'multipart/form-data',
                  },
              })
                  .then(_response => {
                      window.console.log("Response DOCUMENT STORE: ", _response);
                      commit("STOP_PROCESSING", { root: true });
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_DOCUMENT_VIEW: ({ commit,dispatch, reject }, _formData) => {
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          commit("START_PROCESSING", { root: true });
          return new Promise(resolve => {
              http({
                  url: '/document/view',
                  method: "POST",
                  timeout: 30000,
                  data: _formData
              })
                  .then(_response => {
                      window.console.log("Response DOCUMENT VIEW: ", _response);
                      commit("STOP_PROCESSING", { root: true });
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      commit("SET_SELECTED_DOCUMENT", _response.data.data)
                      resolve(_response.data.data);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_DOCUMENT_DOWNLOAD: ({ commit,dispatch, reject }, _data) => {
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          commit("START_PROCESSING", { root: true });
          return new Promise(resolve => {
              http({
                  url: _data.url,
                  method: "POST",
                  timeout: 30000,
                  withCredentials : false,
                  responseType: 'blob'
              })
                  .then(_response => {
                      window.console.log("Response DOCUMENT DOWNLOAD: ", _response);
                      commit("STOP_PROCESSING", { root: true });

                      const blob = new Blob([_response.data], { type: _data.mime });
                      const link = document.createElement('a');
                      link.href = URL.createObjectURL(blob);
                      link.download = _data.label;
                      link.click();
                      URL.revokeObjectURL(link.href);
                      resolve();
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
  },
};
